/**
 * MembershipCancelReasonsAdmin.tsx — Admin > Cancellation Reasons.
 *
 * The corporate dashboard's membership Cancellation Reasons page for the
 * signed-in account (see ReasonListAdmin for the list and form). Reads and
 * writes /v5/membership-cancel-reasons — the reasons a membership cancel
 * offers.
 */
import { ReasonListAdmin } from '@/components/admin/ReasonListAdmin';
import { membershipCancelReasonsApi } from '@/services/reasons.service';

const TEXT = {
  title: 'Cancellation Reasons',
  subtitle: 'Manage membership cancellation reasons.',
  noun: ['reason', 'reasons'] as [string, string],
  thing: 'cancellation reason',
  searchLabel: 'Search cancellation reasons',
  emptyTitle: 'No cancellation reasons found',
  idPrefix: 'membership-cancel-reasons',
};

export function MembershipCancelReasonsAdmin() {
  return <ReasonListAdmin api={membershipCancelReasonsApi} text={TEXT} />;
}
